
import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { 
  CharacterFeatureBase,
  Subrace 
} from "@dndModels";

/**
 * This represents a race with the options chosen for a character.
 */
export class CharacterSubrace extends CharacterFeatureSource {
  source: Subrace | null = null;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      if (this.source_id === "" && obj.subrace_id) {
        this.source_id = obj.subrace_id;
      }
      if (this.char_feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          const fb = new CharacterFeatureBase(o);
          fb.source_id = this.source_id;
          fb.source_name = this.name;
          fb.source_type = "Subrace";
          // fb.root_id = this.source_id;
          // fb.root_name = this.name; 
          // fb.root_type = "Subrace";
          fb.ancestries = [...this.ancestries.map(o => { return {...o}; })];
          this.char_feature_bases.push(fb);
        });
      }
    }
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj
    };
  }

  clone(drop_ids = false): CharacterSubrace {
    const clone = new CharacterSubrace();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterSubrace, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.source = copyMe.source;
  }
}